// @see https://docs.chartbeat.com/cbp/tracking/standard-websites/configuration-variables
// @see https://docs.chartbeat.com/cbp/tracking/standard-websites/single-page-apps
// @see https://docs.chartbeat.com/cbp/feature-integrations/conversion/adding-subscriptions.js-to-your-site

function loadChartbeatScript() {
    const e = document.createElement('script');
    const n = document.getElementsByTagName('script')[0];
    e.type = 'text/javascript';
    e.async = true;
    e.src = '//static.chartbeat.com/js/chartbeat.js';
    n.parentNode.insertBefore(e, n);
}

function loadChartbeatMab() {
    const e = document.createElement('script');
    e.async = true;
    e.src = '//static.chartbeat.com/js/chartbeat_mab.js';
    document.head.appendChild(e);
}

// Chartbeat's recommended loader for subscriptions.js (creates a queue before script loads)
function loadChartbeatSubscriptions() {
    (function(w, d, s, c, u) {
        var qf = function(e, a) {
            (w[c].q = w[c].q || []).push([e, a]);
        };
        w[c] = w[c] || qf;
        var st = d.createElement(s);
        var fs = d.getElementsByTagName(s)[0];
        st.async = 1;
        st.src = u;
        fs.parentNode.insertBefore(st, fs);
    })(window, document, 'script', 'chartbeat', 'https://static.chartbeat.com/js/subscriptions.js');
}

// "/news/crime-courts/" -> "Crime Courts"
function formatSection(sectionPath) {
    if (!sectionPath || sectionPath === '/') return '';

    const segments = sectionPath.split('/').filter(Boolean);
    if (segments.length === 0) return '';

    const section = segments[segments.length - 1];
    return section
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
}

export default function chartbeatPlugin(config) {
    let isLoaded = false;
    let isInitialPage = true;

    return {
        name: 'chartbeat',
        config: config,

        initialize: ({ config }) => {
            const { uid, domain, pageMeta = {}, conversionEnabled = false, subscriberStatus } = config;

            // Subscriber engagement tracking
            // @see https://docs.chartbeat.com/cbp/tracking/standard-websites/subscriber-engagement
            if (subscriberStatus) {
                var _cbq = window._cbq = (window._cbq || []);
                _cbq.push(['_acct', subscriberStatus]);
            }

            const sfConfig = window._sf_async_config = (window._sf_async_config || {});
            sfConfig.uid = uid;
            sfConfig.domain = domain;
            sfConfig.flickerControl = false;
            sfConfig.useCanonical = true;
            sfConfig.useCanonicalDomain = true;

            sfConfig.sections = formatSection(pageMeta.section) || '';
            sfConfig.authors = pageMeta.author || '';

            loadChartbeatScript();
            loadChartbeatMab();

            if (conversionEnabled) {
                loadChartbeatSubscriptions();
            }

            isLoaded = true;
        },

        loaded: () => {
            return isLoaded && typeof window.pSUPERFLY !== 'undefined';
        },

        page: ({ payload }) => {
            if (isInitialPage) {
                isInitialPage = false;
                return;
            }

            if (!window.pSUPERFLY) return;

            const { properties = {} } = payload;

            window.pSUPERFLY.virtualPage({
                sections: formatSection(properties.section) || '',
                authors: properties.author || '',
                path: properties.path || window.location.pathname,
                title: properties.title || document.title,
            });
        },

        // Maps app events to Chartbeat conversion events.
        // @see https://docs.chartbeat.com/cbp/feature-integrations/conversion/conversion-events
        track: ({ payload }) => {
            if (!config.conversionEnabled) return;
            if (typeof window.chartbeat !== 'function') return;

            const { event, properties = {} } = payload;
            if (!event) return;

            let chartbeatEvent;
            const params = {};

            switch (event) {
                // Paywall funnel
                case 'DisplaySubscribePrompt':
                    chartbeatEvent = 'trackPaywallShown';
                    break;
                case 'AddToCart':
                    chartbeatEvent = 'trackPaywallStart';
                    break;
                case 'Purchase':
                    chartbeatEvent = 'trackPaywallComplete';
                    if (properties.products && properties.products[0]) {
                        params.eventLabel = properties.products[0].name;
                    }
                    if (properties.total) {
                        params.eventValue = parseFloat(properties.total);
                    }
                    break;

                // Registration funnel
                case 'DisplayRegistrationWall':
                    chartbeatEvent = 'trackRegistrationShown';
                    break;
                case 'SubmitRegistrationWall':
                    chartbeatEvent = 'trackRegistrationStart';
                    break;
                case 'CompleteRegistrationWall':
                    chartbeatEvent = 'trackRegistrationComplete';
                    break;

                default:
                    return;
            }

            window.chartbeat(chartbeatEvent, params);
        },
    };
}
